/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

module.exports = checkGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/why-did-you-update/~/lodash/_checkGlobal.js
// module id = 717
// module chunks = 0